import React from 'react';

const Input = ({ label, icon: Icon, error, ...props }) => (
  <div className="space-y-1.5">
    {label && <label className="text-sm font-medium text-[#9AA4B2]">{label}</label>}
    <div className="relative">
      {Icon && (
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-[#6B7280]">
          <Icon className="w-4 h-4" />
        </div>
      )}
      <input
        className={`
          w-full bg-[#121C2E] border rounded-lg px-4 py-2.5 text-[#E6ECF5]
          placeholder:text-[#6B7280] focus:outline-none focus:ring-2 focus:ring-[#4F7DF3]/50
          transition-all duration-200
          ${Icon ? 'pl-10' : ''}
          ${error ? 'border-[#E5533D]/50' : 'border-[#1F2A44] hover:border-[#1F2A44]/80'}
        `}
        {...props}
      />
    </div>
    {error && <p className="text-xs text-[#E5533D]">{error}</p>}
  </div>
);

export default Input;
